<template>
  <div>
	  <div v-if="false">
		<nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Control interno</li>
                <li class="breadcrumb-item active" aria-current="page">Dashboard de Logs</li>
            </ol>
        </nav>

		<div class="container-fluid">
			<vx-card class="mb-5">
				<div class="vx-row">
					<h1 class="vx-col w-full bold big-title m-0">Dashboard de <span>Logs</span>.</h1>
				</div>
				<hr />
				<div class="vx-row mb-10">
					<div class="vx-col w-full">
						<h4 class="bold">Consultar la lista de logs relacionados a usuarios de la plataforma.</h4>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col w-1/2">
						<vs-input
							class="w-full mb-4" 
							label="Filtrar por UID *"
							placeholder="Requerido"
							v-model.lazy="userId" />
					</div>
					<div class="vx-col w-1/2">
						<vs-input
							class="w-full mb-4" 
							label="Id de cuenta (Proveedor o inversionista)"
							placeholder="Opcional"
							v-model.lazy="accountId" />
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col w-1/2">
						<label class="vs-input--label">Fecha de inicio *</label>
          				<datepicker
						  	class="w-full mb-4" 
							v-model="endDate"
							:disabledDates="disabledDates"
							:language="es"
							format="dd/MM/yyyy"
							placeholder="Requerido" />
					</div>
					<div class="vx-col w-1/2">
						<label class="vs-input--label">Fecha de término *</label>
						<datepicker
						  	class="w-full mb-4" 
							v-model="startDate"
							:disabledDates="disabledDates"
							:language="es"
							format="dd/MM/yyyy"
							placeholder="Requerido" />
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col w-1/3">
						<label class="vs-input--label">Categoría</label>
						<v-select
							label="text"
							class="vs-custom w-full mb-4"
							v-model.lazy="category"
							:options="categoriesList"
							:reduce="text => text.value"
							:clearable="false"
							:searchable="true"
							placeholder="Seleccione una opción">
							<div slot="no-options">No hay coincidencias</div> 
						</v-select>
					</div>
					<div class="vx-col w-1/3">
						<label class="vs-input--label">Clasificación</label>
						<v-select
							label="text"
							class="vs-custom w-full mb-4"
							v-model.lazy="classification"
							:options="classificationsList"
							:reduce="text => text.value"
							:clearable="false"
							:searchable="true"
							placeholder="Seleccione una opción">
							<div slot="no-options">No hay coincidencias</div> 
						</v-select>
					</div>
					<div class="vx-col w-1/3">
						<label class="vs-input--label">Operation</label>
						<v-select
							label="text"
							class="vs-custom w-full mb-4"
							v-model.lazy="operation"
							:options="operationsList"
							:reduce="text => text.value"
							:clearable="false"
							:searchable="true"
							placeholder="Seleccione una opción">
							<div slot="no-options">No hay coincidencias</div> 
						</v-select>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col w-1/2">
						<label class="vs-input--label">Filtrar por rol</label>
						<v-select
							label="text"
							class="vs-custom w-full mb-4"
							v-model.lazy="selectedRole"
							:options="rolesList"
							:reduce="text => text.value"
							:clearable="false"
							:searchable="true"
							placeholder="Seleccione una opción">
							<div slot="no-options">No hay coincidencias</div> 
						</v-select>
					</div>
					<div class="vx-col w-1/2">
						<label class="vs-input--label">Filtrar por aplicación</label>
						<v-select
							label="text"
							class="vs-custom w-full mb-4"
							v-model.lazy="selectedApp"
							:options="appsList"
							:reduce="text => text.value"
							:clearable="false"
							:searchable="true"
							placeholder="Seleccione una opción">
							<div slot="no-options">No hay coincidencias</div> 
						</v-select>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col w-full">
						<vs-input
							class="w-full" 
							label="Payload"
							v-model.lazy="payload" />
					</div>
					<div class="vx-col w-full">
						<span>Ejemplo: <strong>PID = 2987,UID = 493,statusId >= 1</strong></span>
					</div>
				</div>
				<div class="vx-row mb-4">
					<div class="vx-col w-full">
						<vs-chip
							class="bold"
							v-for="(payloadValue, index) in payloadValues" 
							:key="index">
							{{ `${payloadValue.key} ${payloadValue.operator} ${payloadValue.value}` }}
						</vs-chip>
					</div>
				</div>
				<div class="vx-row">
					<vs-button class="vx-col w-full mx-4" @click="handleSearch">Buscar</vs-button>
				</div>
			</vx-card>
			<vx-card title="Listado de logs" class="mb-5">
				<vs-table :data="logsList" stripe search noDataText="No se encontraron registros" pagination :max-items="100">
					<template slot="thead">
						<vs-th class="bold" sort-key="name">UID</vs-th>
						<vs-th class="bold" sort-key="alias">ALIAS</vs-th>
						<vs-th class="bold" sort-key="email">EMAIL</vs-th>
						<vs-th class="bold" sort-key="app">APP</vs-th>
						<vs-th class="bold" sort-key="role_id">ROLE</vs-th>
						<vs-th class="bold" sort-key="rg_account">RG ACCOUNT</vs-th>
						<vs-th class="bold" sort-key="log_category_name">CATEGORÍA</vs-th>
						<vs-th class="bold" sort-key="log_classification_name">CLASIFICACIÓN</vs-th>
						<vs-th class="bold" sort-key="log_operation_name">OPERACIÓN</vs-th>
						<vs-th class="bold">PAYLOAD</vs-th>
						<vs-th class="bold" sort-key="created_at">FECHA DE CREACIÓN</vs-th>
					</template>
					<template slot-scope="{data}">
						<vs-tr :key="index" v-for="(tableRow, index) in data">
							<vs-td :data="data[index].user_id">{{ data[index].user_id }}</vs-td>
							<vs-td :data="data[index].alias">{{ data[index].alias }}</vs-td>
							<vs-td :data="data[index].email">{{ data[index].email }}</vs-td>
							<vs-td :data="data[index].app">{{ data[index].app }}</vs-td>
							<vs-td :data="data[index].role_id">{{ data[index].role_id }}</vs-td>
							<vs-td :data="data[index].rg_account">{{ data[index].rg_account }}</vs-td>
							<vs-td :data="data[index].log_category_name">{{ data[index].log_category_name }}</vs-td>
							<vs-td :data="data[index].log_classification_name">{{ data[index].log_classification_name }}</vs-td>
							<vs-td :data="data[index].log_operation_name">{{ data[index].log_operation_name }}</vs-td>
							<vs-td :data="data[index].payload">{{ getPayload(data[index].payload) }}</vs-td>
							<vs-td :data="data[index].created_at">{{ data[index].created_at }}</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vx-card>
		</div>
	</div>
    <div v-else>
      <vs-alert>Esta pagina ha sido deshabilitada</vs-alert>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import {es} from "vuejs-datepicker/dist/locale";

export default {
	name: 'LogsDashboard',
	components: {
		Datepicker
	},
	data() {
		return {
			userId: null,
			accountId: null,
			startDate: new Date(),
			endDate: moment().subtract(59, 'days').format(),
			rolesList: [],
			selectedRole: 0,
			appsList: [ { value: 0, text: 'Todas' }, { value: 1, text: 'App' }, { value: 2, text: 'BackOffice' } ],
			selectedApp: 0,
			category: null,
			classification: null,
			operation: null,
			payload: null,
			payloadValues: [],
			categoriesList: [],
			classificationsList: [],
			operationsList: [],
			logsList: [],
			es: es,
		}
	},
	async mounted() {
		//await this.getRolesList();
	  //await this.getCategoriesList();
	},
	methods: {
		async getCategoriesList() {
			try {
				const {data} = await axios.get('api/v1/log-categories');
				this.categoriesList = data.categories.map((value) => ({ value: value.id, text: value.name }));
				this.categoriesList.unshift({ value: 0, text: 'Ninguno' });
				this.classificationsList = data.classifications.map((value) => ({ value: value.id, text: value.name }));
				this.classificationsList.unshift({ value: 0, text: 'Ninguno' });
				this.operationsList = data.operations.map((value) => ({ value: value.id, text: value.name }));
				this.operationsList.unshift({ value: 0, text: 'Ninguno' });
			} catch (error) {
				console.log(error);
				this.warn(error);
			}
		},
		async handleSearch() {
			try {
				const diffTime = Math.abs(this.startDate - this.endDate);
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
	
				if(diffDays > 60) {
					this.warningNotif('Diferencia de fechas', 'El rango máximo entre fechas es de 60 días');
					return;
				}
				if(this.userId === null || this.userId === undefined) {
					this.warningNotif('Id de usuario', 'El UID no puede quedar vacío');
					return;
				}
			
				this.showLoading(true);
				const {data} = await axios.post('/api/v1/log', {
					userId: this.userId,
					accountId: this.accountId,
					startDate: this.startDate,
					endDate: this.endDate,
					category: this.category,
					classification: this.classification,
					operation: this.operation,
					selectedRole: this.selectedRole,
					selectedApp: this.selectedApp,
					payloadValues: this.payloadValues
				});
				this.showLoading(false);
				if(data.success) {
					this.logsList = data.message;
					return;
				}
				this.errorNotif('Error en la consulta', 'Verifica que los filtros determinados en payload sean correctos. El error se puede visualizar en consola');
				console.error(data.message);
			}
			catch (error) {
				console.log(error);
				this.errorNotif('Error en la operación', error);
			}
			this.showLoading(false);
		},
		async getRolesList() {
			try {
				const {data} = await axios.get('api/roles');
				this.rolesList = data.map((role) => ({ value: role.id, text: role.name }));
			}
			catch (error) {
				console.log(error);
				this.errorNotif('Error en la operación', error);
			}
		},
		getPayload(payload) {
			return payload;
		},
		formatPayload() {
			this.payloadValues = [];
			let segment = [ '', '', '' ], 
				segmentCounter = 0;

			for(let i = 0; i < this.payload.length; i++) {
				if(this.payload[i] == ',') {
					if(segment[0] != '' || segment[1] != '' || segment[2] != '')
						this.payloadValues.push({ key: segment[0], operator: segment[1], value: segment[2] });
					segment = [ '', '', '' ];
					segmentCounter = 0;
					continue;
				}
				if(this.payload[i] == ' ') {
					segmentCounter++;
					continue;
				}
				segment[segmentCounter] += this.payload[i];
			}
			if(segment[0] != '' || segment[1] != '' || segment[2] != '')
				this.payloadValues.push({ key: segment[0], operator: segment[1], value: segment[2] });
		}
	},
	computed: {
		disabledDates() {
			return {
				from: this.startDate
			}
		}
	},
	watch: {
		payload() {
			if(this.payloadTimer)
				clearTimeout(this.payloadTimer);
			this.payloadTimer = setTimeout(() => this.formatPayload(), 1000);
		}
	}
}
</script>